import { render, staticRenderFns } from "./UpdateClientProfile.vue?vue&type=template&id=e4a65906&scoped=true"
import script from "./UpdateClientProfile.vue?vue&type=script&lang=js"
export * from "./UpdateClientProfile.vue?vue&type=script&lang=js"
import style0 from "./UpdateClientProfile.vue?vue&type=style&index=0&id=e4a65906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a65906",
  null
  
)

export default component.exports